import history from 'utils/history';
import { getFilterFieldValue } from 'utils/commonUtil';

const store = new Map();

export function makeFilterKey(pathname, tabKey) {
  return `filter::${pathname || ''}::${tabKey ?? ''}`;
}

export function getPersistedReportModel(tabKey, pathname = history.location.pathname) {
  const saved = store.get(makeFilterKey(pathname, tabKey));
  if (!saved?.keys?.length) return null;
  const reportModel = getFilterFieldValue(saved.reportModel);
  return reportModel?.length ? reportModel : null;
}

function pathnameOfKey(key) {
  const parts = key.split('::');
  return parts.length >= 2 ? parts[1] : null;
}

history.listen(location => {
  const path = location.pathname;
  Array.from(store.keys()).forEach(key => {
    const keyPath = pathnameOfKey(key);
    if (!keyPath) return;
    if (path === keyPath || path.startsWith(`${keyPath}/`)) return;
    store.delete(key);
  });
});

export function getPersistedFilter(key) {
  return store.get(key);
}

export function setPersistedFilter(key, value) {
  store.set(key, value);
}

export function clearPersistedFilter(key) {
  store.delete(key);
}

export function clearAllPersistedFilters() {
  store.clear();
}
